export default __webpack_public_path__ + "static/media/doctor2.9c2e8f2b.svg";